<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('marca') }}:</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('promotor') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('cadastros') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'marca-list' })">{{
                                        $t('marcas')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        !marca.idmarca ? $t('nova-marca') : marca.descricao
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: 'marca-list',
                                })
                            "
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                ((!isUpdate && permissao.create) ||
                                    (isUpdate && permissao.update)) &&
                                !marcaIntegracao
                            "
                            class="save-btn"
                            type="button"
                            @click="salvar()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit page-container">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="'codigo'"
                                ref="idmarcaerp"
                                v-model="marca.idmarcaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                            />
                        </div>
                        <div class="column is-8">
                            <v-input
                                v-model="marca.descricao"
                                :id="'descricao'"
                                :placeholder="'descricao-da-marca-placeholder'"
                                :maxlength="50"
                                :title="'descricao-marca'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!marca.descricao"
                                ref="descricaoInput"
                                :required="true"
                            />
                        </div>
                        <div class="column is-2">
                            <label for="situacao" v-text="$t('situacao-marca')" />
                            <v-select
                                ref="situacaoSelect"
                                :selectOnTab="true"
                                :searchable="false"
                                :options="situacoes"
                                :value="situacao"
                                @input="updateSituacao"
                                :getOptionLabel="getLabel"
                                placeholder="situacao-da-marca-placeholder"
                                class="no-clear"
                            >
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MarcaService from '@/services/MarcaService';
import MarcaValidation from '@/services/validations/MarcaValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            marcaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('MARCA'),
            isSaving: false,
            marca: {
                idmarcaerp: null,
                situacao: 1,
            },
            editable: false,
            title: '',
            msgs: [],
            situacao: { label: 'ativo', id: 1 },
            situacoes: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            isUpdate: false,
        };
    },
    created() {
        if (this.marca != null && this.marca != {}) {
            this.editable = true;
        }

        this.service = new MarcaService(this.$http, this.$router);
        this.validation = new MarcaValidation(this.msgs);

        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'marcas');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'marca' },
            });
        } else {
            this.isUpdate = !!this.$route.params.id;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'marca' },
                });
            }

            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
        let search = this.$refs.situacaoSelect.$refs.search;
        search.addEventListener('keydown', (e) => {
            if (e.code == 'Tab') {
                search.focus();
            }
        });
    },
    methods: {
        carregarDados(id) {
            this.$store.commit('addLoader');
            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.marca = body.content;
                        this.title = this.marca.descricao;
                        this.situacao = this.getSituacao();
                    } else {
                        this.$router.push({ name: 'marca-new' });
                    }
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },
        getSituacao() {
            return this.situacoes.filter((s) => s.id == this.marca.situacao);
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.marca.situacao = situacao.id;
                this.situacao = situacao;
            }
        },
        salvar(redirect = this.redirectToList) {
            this.marca = this.mapTosave(this.marca);
            if (this.validation.validate(this.marca, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(this.marca)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-marca-salvo';
                            if (this.marca.id) {
                                msg = 'msg-marca-editado';
                            }
                            this.marca = body.content;
                            this.msgs.push(new Message('success', msg, true));
                            redirect(2);
                        } else {
                            if (this.$t(body.message)) {
                                this.msgs.push(new Message('alert', body.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch();
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'marca-list',
                });
            }, time * 1000 + 50);
        },
        redirectToEdit(time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'marca-edit',
                    params: { id: this.marca.idmarca },
                });
            }, time * 1000 + 50);
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    #main {
        padding: 0 20px;
        height: auto;
    }
    .page {
        position: relative;
    }
}
</style>
